import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';

import { Location } from 'history';

import { initApp, showMessage } from '@lib/actions';
import storageService from '@lib/services/storageService';
import axiosClient from '@lib/utils/axiosClient';

type Data = { patientId: string; code: string; location?: Location };
type Response = { token: string };

export default function usePatientVerify() {
  const dispatch = useDispatch();

  const mutationFn = async ({ patientId, code, location }: Data) => {
    const { data } = await axiosClient.post(`/patients/${patientId}/verify`, { code });
    const response: Response = data;

    // Refresh token, initialize app again and submit form item
    storageService.setToken(response.token);
    await new Promise((resolve, reject) => {
      dispatch(
        initApp.request({
          location,
          meta: {
            callbackSuccess: resolve,
            callbackError: reject,
          },
        }),
      );
    });
    return data;
  };

  const mutation = useMutation(mutationFn, {
    // TODO: Make errors management generic to all `react-query` mutations
    onError: (error: Error) => {
      dispatch(showMessage(error.message, 'error'));
    },
  });

  return mutation;
}
